/**
 * Get the URLSearchParameter as a JSON
 *
 * @return {{}}
 */
window.getUrlVars = function getUrlVars() {
    var vars = {};
    decodeURIComponent(window.location.href).replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}
